import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { gql, useMutation } from "@apollo/client";
import Scalling from "../dashoboard/UserDashCandidate";
import Nuevo from "../icons/nuevo";
import "./Dashboard.css";

const APLICAR_JOB = gql`
  mutation AplicarJob(
    $idJob: String!
    $username: String!
    $idUserlink: String!
    $name: String!
    $email: String!
    $emailOwner: String!
  ) {
    AplicarJob(
      idJob: $idJob
      username: $username
      idUserlink: $idUserlink
      name: $name
      email: $email
      emailOwner: $emailOwner
    ) {
      _id
      name
    }
  }
`;

const Dashboard = ({
  username,
  idUserlink,
  destinatario,
  email,
  idJob,
  emailOwner,
  onCandidateApplied,
  onOpenChat
}) => {
  const [activeTab, setActiveTab] = useState("Resumen");
  const [showNotification, setShowNotification] = useState(false);
  const location = useLocation();

  const [aplicarJob] = useMutation(APLICAR_JOB);

  const handleAplicarJob = () => {
    aplicarJob({
      variables: {
        idJob,
        username,
        idUserlink,
        name: destinatario,
        email,
        emailOwner,
      },
    })
      .then((response) => {
        console.log("Aplicación exitosa:", response.data);
        setShowNotification(true);
        if (onCandidateApplied) {
          onCandidateApplied(response.data.AplicarJob);
        }
        setTimeout(() => {
          setShowNotification(false);
        }, 3000);
      })
      .catch((err) => {
        console.error("Error al aplicar al puesto:", err);
      });
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <div className="dashboard-container">
      {showNotification && (
        <div
          className="floating-notification"
          style={{
            position: "fixed",
            right: "20px",
            top: "20px",
            backgroundColor: "#28a745",
            color: "white",
            padding: "10px 20px",
            borderRadius: "5px",
            zIndex: 1000,
          }}
        >
          {destinatario}, es agregada para plicar al puesto
        </div>
      )}
      <nav className="dashboard-tabs">
        <ul className="tabs-list">
          {["Resumen", "Scalling", "MBTI", "Big Five", "Datos", "CV"].map(
            (tab) => (
              <li
                key={tab}
                className={`tab-item ${activeTab === tab ? "active" : ""}`}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </li>
            )
          )}
        </ul>
      </nav>
      {activeTab === "Resumen" && (
        <div className="tab-content">
          <section className="dashboard-status">
            <div className="status-box">
              <span className="status-title status-active">Activo</span>
              <span className="status-subtitle">
                Contratado el 29/01/2025
              </span>
            </div>
            <div className="status-box">
              <span className="status-title status-incorporado">
                INCORPORADO
              </span>
              <span className="status-subtitle">29/01/2027</span>
            </div>
          </section>
          <section className="dashboard-main">
            <div className="left-column">
              <div className="card card-contact">
                <h3 className="card-title">Detalle de contacto</h3>
                <p className="card-content">{email}</p>
              </div>
              <div className="card card-status">
                <h3 className="card-title">Saber mas...</h3>
                <span className="chat-icon-container" onClick={onOpenChat}>
                  <Nuevo size={7} />
                  <p>Chatear</p>
                </span>
              </div>
              <button className="btn-update-link">Actualizar link</button>
            </div>
            <div className="right-column">
              <div className="card card-usage">
                <h3 className="card-title">Recursos completados</h3>
                <div className="usage-item">
                  <span className="usage-label">Tests psicométricos</span>
                  <span className="usage-value">1 de 5</span>
                </div>
                <div className="usage-item">
                  <span className="usage-label">Test duros</span>
                  <span className="usage-value">0 de 5</span>
                </div>
                <div className="usage-item">
                  <span className="usage-label">
                    Candidaturas en curso
                  </span>
                  <span className="usage-value">0 de 47</span>
                </div>
              </div>
              <div className="card card-usage">
                <h3 className="site-info-title">Habilidades duras</h3>
                <button className="btn-manage-parking">
                  Enviar test adicional
                </button>
              </div>
            </div>
          </section>
          <section className="dashboard-parking">
            <div className="parking-left">
              <h3 className="parking-title">Simular situaciones</h3>
              <div className="parking-preview">
                <span>Vista previa de actitudes - Rol Play</span>
              </div>
              <button className="btn-customize-parking">
                Proyectar carrera
              </button>
            </div>
          </section>
          <div className="card card-actions">
            <button className="btn-action" onClick={handleAplicarJob}>
              Aplicar a este puesto
            </button>
            <button className="btn-action">Vincular a otro puesto</button>
          </div>
        </div>
      )}
      {activeTab === "Scalling" && (
        <div className="tab-content">
          <Scalling username={username} idUserlink={idUserlink} />
        </div>
      )}
      {activeTab === "MBTI" && (
        <div className="tab-content">
          <h2>MBTI</h2>
          <p>Contenido o dashboard específico para MBTI.</p>
        </div>
      )}
      {activeTab === "Big Five" && (
        <div className="tab-content">
          <h2>Big Five</h2>
          <p>Contenido o dashboard específico para Big Five.</p>
        </div>
      )}
      {activeTab === "Datos" && (
        <div className="tab-content">
          <h2>Datos</h2>
          <p>Contenido o dashboard específico para INFO.</p>
        </div>
      )}
      {activeTab === "CV" && (
        <div className="tab-content">
          <h2>CV</h2>
          <p>Contenido o dashboard específico para CV.</p>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
